import React from "react";

import { FormattedMessage, useIntl } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";

import { ReactComponent as IconPlay18 } from "../../icons/icon/18/a-icon-play-18.svg";
import Button from "../button/button";

import "./videoBackgroundPlayer.scss";

const PlayVideoButton = ({ videoPlayerRef }) => {
  const intl = useIntl();

  return (
    <Button
      onClick={() => {
        videoPlayerRef.current?.openVideo();
      }}
      variant="text-light"
      className="video-background-player__video-button"
      title={intl.formatMessage({ id: "video.play" })}
    >
      <IconPlay18 className="mr-9" /> <FormattedMessage id="video.play" />
    </Button>
  );
};

PlayVideoButton.propTypes = {
  videoPlayerRef: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default PlayVideoButton;
